const MAX_DIMENSION = 1920;

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

export async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  let outputCanvas = canvas;
  if (Math.max(canvas.width, canvas.height) > MAX_DIMENSION) {
    const scale = MAX_DIMENSION / Math.max(canvas.width, canvas.height);
    outputCanvas = document.createElement('canvas');
    outputCanvas.width = Math.round(canvas.width * scale);
    outputCanvas.height = Math.round(canvas.height * scale);
    outputCanvas.getContext('2d').drawImage(canvas, 0, 0, outputCanvas.width, outputCanvas.height);
  }

  return new Promise((resolve) => {
    outputCanvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9);
  });
}
